// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3qd-x","image":"Header_image__NAxpL","name":"Header_name__1eMHK","info":"Header_info__2f-qQ","infoRow":"Header_infoRow__mupnv"};